import TermsAllList from '@/component/terms/TermsAllList';
import CheckEmail from '@/component/users/common/CheckEmail';
import SendEmail from '@/component/users/common/SendEmail';

export default function Join() {
  // TODO input 데이터로 이메일 받아야 함
  const email = 'rnwpgjs@naver.com';
  return (
    <>
      <TermsAllList />
      <CheckEmail email={email} />
      <SendEmail email={email} lang="KO" />
    </>
  );
}
